var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 117.44 89.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-4);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#fff;stroke-width:2px;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-2{fill:url(#linear-gradient-6);}.cls-3{fill:#7da2fe;stroke-linecap:round;stroke-linejoin:round;}.cls-8{opacity:.15;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-3);}.cls-9{fill:#020004;}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.75,
    y1: 45.76,
    x2: 34,
    y2: 45.76,
    gradientTransform: "translate(94.69) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 41.72,
    x2: 52.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 60.68,
    x2: 71.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 45.5,
    y1: 29.75,
    x2: 56.75,
    y2: 29.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 64.47,
    y1: 29.75,
    x2: 75.72,
    y2: 29.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 83.43,
    y1: 29.75,
    x2: 94.69,
    y2: 29.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M89.92,35.34v36.48c0,5.71-4.67,10.39-10.39,10.39H10.39l-8.93,7.5c-.58,.48-1.46,.07-1.46-.68V35.34c0-5.71,4.67-10.39,10.39-10.39H79.53c5.71,0,10.39,4.67,10.39,10.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.69,27.4V63.87c0,5.71-4.67,10.39-10.39,10.39H15.16l-10.39,8.72V27.4c0-5.71,4.67-10.39,10.39-10.39H84.3c5.71,0,10.39,4.67,10.39,10.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66.31,
    cy: 45.76,
    r: 5.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 47.34,
    cy: 45.76,
    r: 5.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 28.38,
    cy: 45.76,
    r: 5.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.52,19.33V55.81c0,5.71,4.67,10.39,10.39,10.39H107.05l8.93,7.5c.58,.48,1.46,.07,1.46-.68V19.33c0-5.71-4.67-10.39-10.39-10.39H37.91c-5.71,0-10.39,4.67-10.39,10.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.75,11.39V47.86c0,5.71,4.67,10.39,10.39,10.39H102.28l10.39,8.72V11.39c0-5.71-4.67-10.39-10.39-10.39H33.14c-5.71,0-10.39,4.67-10.39,10.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.13,
    cy: 29.75,
    r: 5.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 70.09,
    cy: 29.75,
    r: 5.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89.06,
    cy: 29.75,
    r: 5.63
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.5334ad8d9d43c3c1ac34bc51f0ea8110.svg";
export { ForwardRef as ReactComponent };